import { queryClient } from 'index';
import { useQuery } from 'react-query';
import { EadNode, ArchivalAidMetadata, Result, ArchivalUnitCopy } from 'types';

export const fetchEadChildren = async (ids: string[]) => {
  const body = [...ids];
  const resp = await queryClient.fetchQuery(['children', ...ids], () =>
    fetch(process.env.PUBLIC_URL + '/api/archival-aid-metadata/ead/list', {
      method: 'POST',
      body: JSON.stringify(body),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    }).then(async (r) => ((await r.json()) as unknown) as EadNode[])
  );
  return resp;
};

export const fetchAidChildren = async (aid: ArchivalAidMetadata) => {
  const body = {
    sort: [{ field: 'numericId', order: 'ASC' }],
    filters: [
      {
        field: 'describingArchivalAids.id',
        operation: 'EQ',
        value: aid.id,
      },
    ],
    size: -1,
  };

  const resp = await queryClient.fetchQuery(['aid-children', aid.id], () =>
    fetch(process.env.PUBLIC_URL + '/api/archival-unit/public/list', {
      method: 'POST',
      body: JSON.stringify(body),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    }).then(
      async (r) => ((await r.json()) as unknown) as Result<ArchivalUnitCopy>
    )
  );
  return resp;
};

export const useAidsListByOriginator = (id?: string) =>
  useQuery(
    ['originator-list', id],
    () =>
      fetch(
        process.env.PUBLIC_URL +
          `/api/archival-aid-metadata/list-by-originator?originatorId=${id}`
      ).then(
        async (r) => (await r.json()) as Record<string, ArchivalAidMetadata[]>
      ),
    { enabled: !!id }
  );
